// In: src/components/common/SectionTitle.js

import React from 'react';
import { Title, Group, Text, useMantineTheme, useMantineColorScheme } from '@mantine/core';

const SectionTitle = ({ order, section, number, title }) => {
  const id = `section-${section.replace(/\./g, '-')}`;
  const theme = useMantineTheme();
  const isDark = useMantineColorScheme().colorScheme === 'dark';

  return (
    <Title
      order={order}
      id={id}
      style={{ scrollMarginTop: '80px' }}
    >
      <Group gap="sm" align="baseline">
        <Text
          component="span"
          c={isDark ? 'gray.6' : 'gray.5'}
          inherit
        >
          {number}
        </Text>
        {title && <Text component="span" inherit>{title}</Text>}
      </Group>
    </Title>
  );
};

export default SectionTitle;